const _invoiceId = Symbol();
const _productId = Symbol();
const _quantity = Symbol();
const _shortageQuantity = Symbol();
const _density = Symbol();
const _errs = Symbol();

class InvoiceDetail {
    constructor({ invoiceId, productId, quantity, shortageQuantity, density }) {
        this[_errs] = {};
        Object.defineProperties(this, {
            invoiceId: {
                enumerable: true,
                configurable: true,
                set: function (value = null) {
                    this[_invoiceId] = value;
                },
                get: function () {
                    return this[_invoiceId];
                }
            },
            productId: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseInt(value, 10);
                    if (x) {
                        this[_productId] = x;
                        delete this[_errs].productId;
                    } else {
                        this[_errs].productId = "productId must be a valid integer";
                    }
                },
                get: function () {
                    return this[_productId];
                }
            },
            quantity: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    let x = parseFloat(value);
                    if (x) {
                        this[_quantity] = x;
                        delete this[_errs].quantity;
                    } else {
                        this[_errs].quantity = "Enter a valid quantity";
                    }
                },
                get: function () {
                    return this[_quantity];
                }
            },
            shortageQuantity: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    var v = parseInt(value, 10);
                    if (v >= 0) {
                        this[_shortageQuantity] = value;
                        delete this[_errs].shortageQuantity;
                    } else {
                        this[_errs].shortageQuantity = "shortageQuantity must be a valid integer";
                    }
                },
                get: function () {
                    return this[_shortageQuantity];
                }
            },
            density: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 45) {
                        this[_density] = value.toUpperCase();
                        delete this[_errs].density;
                    } else {
                        this[_errs].density = "Please enter base density";
                    }
                },
                get: function () {
                    return this[_density];
                }
            }
        });


        this.invoiceId = invoiceId;
        this.productId = productId;
        this.quantity = quantity;
        this.shortageQuantity = shortageQuantity;
        this.density = density;

    }

    getErrors() {
        return this[_errs];
    }

    hasError() {
        return Object.keys(this[_errs]).length > 0 ? true : false;
    }

}

module.exports = InvoiceDetail;


// WEBPACK FOOTER //
// ./src/models/invoice-detail.js